export const AUTH_API_ROUTES = {
  LOGIN: "/admin/auth/login",
};
